import { render, staticRenderFns } from "./HotelContactCard.vue?vue&type=template&id=23f9548e&scoped=true&"
import script from "./HotelContactCard.vue?vue&type=script&lang=js&"
export * from "./HotelContactCard.vue?vue&type=script&lang=js&"
import style0 from "./HotelContactCard.vue?vue&type=style&index=0&id=23f9548e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9548e",
  null
  
)

export default component.exports